import React from "react";
import { Text, View } from "react-native";

function LessonHistoryEmptyState() {
  return (
    <View className="mx-5 px-4 py-10 bg-teachLoop-creamDark rounded-2xl">
      <Text className="font-geologica-regular text-center text-base text-gray-800 leading-[1.5]">
        You have no lesson history yet.
      </Text>
    </View>
  );
}

export default LessonHistoryEmptyState;

